$shm_hitalama_vk_lists $mol_list
	title \Списки сообществ
	token null $shm_hitalama_vk_token
	sub /
		<= current_view <= Main
	Main $mol_section
		title <= title
		content /
			<= Open_create $mol_link
				title \Создать список
				arg * create true
			<= Lists $mol_list sub <= lists /
				<= List* $mol_list sub /
					<= List_head* $mol_view
						sub /
							<= Name* $mol_paragraph
								title <= name* \
							<= Edit* $mol_link
								title \Редактировать
								arg *
									edit <= ref_str* \
							<= Remove* $mol_button_minor
								title \Удалить
								click? <=> remove_list*? null
					<= Groups* $mol_view
						sub <= groups* /
							<= Group* $mol_view
								sub /
									<= Photo* $mol_image
										uri <= group_photo_uri* \
	Creating $shm_hitalama_vk_lists_creating
		token <= token
	Editing $shm_hitalama_vk_lists_editing
		token <= token
		list <= list_editing $shm_hitalama_vk_list
